import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import styles from '../ManagePage.module.css';

const PaginationControls = ({ totalItems, currentPage, itemsPerPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  if (totalItems <= itemsPerPage) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1)
    .filter(page => page === 1 || page === totalPages || (page >= currentPage - 2 && page <= currentPage + 2));

  return (
    <div className={styles.paginationContainer}>
      <div className={styles.paginationInfo}>
        Showing {((currentPage - 1) * itemsPerPage) + 1}-{Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} projects
      </div>
      <div className={styles.pagination}>
        <button
          className={`${styles.paginationButton} ${currentPage === 1 ? styles.disabled : ''}`}
          onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
          disabled={currentPage === 1}
        >
          <FaChevronLeft />
        </button>
        {pages.map((page, index, array) => (
          <React.Fragment key={page}>
            {index > 0 && array[index - 1] !== page - 1 && (
              <span className={styles.paginationEllipsis}>...</span>
            )}
            <button
              className={`${styles.paginationButton} ${currentPage === page ? styles.active : ''}`}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          </React.Fragment>
        ))}
        <button
          className={`${styles.paginationButton} ${currentPage === totalPages ? styles.disabled : ''}`}
          onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
};

export default PaginationControls;
